// extracted by mini-css-extract-plugin
export default {"TastingCollection":"TastingCollection_TastingCollection__FqLBm","Img":"TastingCollection_Img__ahODg"};